import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import DatatableForOpen from "../../components/datatableForStatusOpen/DatatableForOpen";
import {ticketOpenColumns} from "../../components/datatableTicketSolve/dataticketopen";

const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar/>
        <div className="widgets">
          <Widget type="ticket"/>
          <Widget type="ticketsolved"/>
          <Widget type="details"/>
        </div>
        <div className="listContainer">
          <div className="listTitle">Latest Tikcet Open</div>
          <DatatableForOpen columns={ticketOpenColumns}/>
        </div>
      </div>
    </div>
);
};

export default Home;
